module.exports = __webpack_public_path__ + "static/media/background.75de8b8e.jpeg";